/*
 * @Author: Teemo Ding
 * @Date: 2022-04-21 11:29:08
 * @LastEditTime: 2023-02-17 15:46:25
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/useFilter.tsx
 */
import { Form } from '@/src/components/Antd';
import { useDebounceEffect } from 'ahooks';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import Filter from 'src/components/AdvancedFilter';
import { EAction } from 'src/constrains/AdvancedFilters/Collapse';
import { useI18n } from 'src/hooks/useRouterChange';
import Content from 'src/pages/Analytics/Reports/ReportsDetail/Components/FilterSelect';
import { i18nGet } from 'src/tools/tools';

export enum EFilterType {
  SalesChannel = 'SalesChannel',
  OrderStatus = 'OrderStatus',
  PaymentStatus = 'PaymentStatus',
  FulfillmentStatus = 'FulfillmentStatus',
  PaymentMethod = 'PaymentMethod',
  PaymentGateway = 'PaymentGateway',
  CheckoutType = 'CheckoutType',
  CustomerType = 'CustomerType',
  Warehouse = 'Warehouse',
  LogisticMethod = 'LogisticMethod',
  DeliveryMethod = 'DeliveryMethod',
  ClickCollectPickupPoint = 'ClickCollectPickupPoint',
  DeliveryRecipientCountry = 'DeliveryRecipientCountry',
  TransactionNativeCurrency = 'TransactionNativeCurrency',
  PromotionType = 'PromotionType',
  CustomerDatabase = 'CustomerDatabase',
  RegisteredSalesChannel = 'RegisteredSalesChannel',
  Gender = 'Gender',
  Title = 'Title',
  Language = 'Language',
  ConsentAttribute = 'ConsentAttribute',
  SubscriptionStatus = 'SubscriptionStatus',
  CustomerTags = 'CustomerTags',
  SalesChannelUsage = 'SalesChannelUsage',
  GiftCardNativeCurrency = 'GiftCardNativeCurrency',
  ProductType = 'ProductType',
  ProductTags = 'ProductTags',
  ProductStatus = 'ProductStatus',
  Brand = 'Brand',
  UnitOfMeasurement = 'UnitOfMeasurement',
  SubscriptionPlanName = 'SubscriptionPlanName',
  OrderSalesChannel = 'OrderSalesChannel',
  SalesChannelPaymentMethod = 'SalesChannelPaymentMethod',
  SalesChannelPaymentGateway = 'SalesChannelPaymentGateway',
  OrderWarehouse = 'OrderWarehouse',
  OrderDeliveryMethod = 'OrderDeliveryMethod',
  OrderClickCollectPickupPoint = 'OrderClickCollectPickupPoint',
}

const useFilters = ({ value, onChange }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const ini = Object.values(EFilterType).reduce((pre, now) => {
    pre[`${now}Init`] = { [now]: [] };
    return pre;
  }, {});

  const getOptions = (k: EFilterType) => {
    const target = (value || []).find((i: any) => {
      return get(i, 'type') === k;
    });
    const options = get(target, 'options', []) || [];
    return options;
  };

  const transferValueToSubmit = (values: any) => {
    return (value || []).map((i: any) => {
      const type = get(i, 'type');
      const options = get(i, 'options') || [];
      const allSelected = get(values, type) || [];
      const _options = options.map((o: any) => {
        const value = get(o, 'value');
        const isSelected = allSelected.includes(value);
        return { ...o, selected: isSelected };
      });
      return { ...i, options: _options };
    });
  };
  const iniValue = React.useMemo(
    () =>
      (value || []).reduce((pre: any, now: any) => {
        const type = get(now, 'type');
        const options = get(now, 'options') || [];
        const value = options
          .filter((i: any) => {
            return i.selected;
          })
          .map((o: any) => get(o, 'value'));
        return { ...pre, [type]: value };
      }, {}),
    [value],
  );
  useDebounceEffect(() => {
    form1.setFieldsValue(iniValue);
  }, [iniValue]);

  const [form1] = Form.useForm();
  const [visible, setVisible] = React.useState(false);
  const map = Object.values(EFilterType).reduce((pre, now) => {
    const { header: title } = value.find((item) => item.type === now) || {
      header: '',
    };
    pre[now] = (
      <Content
        title={title}
        noStyle
        form={form1}
        options={getOptions(now)}
        name={[now]}
        defaultState={ini[`${now}Init`]}
      />
    );
    return pre;
  }, {});

  const onClose = () => {
    setVisible(false);
  };

  const resetAll = () => {
    form1.setFieldsValue(
      Object.values(ini).reduce((p, c) => {
        return Object.assign(p, c);
      }, {}),
    );
    window.dispatchEvent(new Event(EAction.CLOSE));
    onClose();
    form1.submit();
  };

  const handleOnSubmit = () => {
    window.dispatchEvent(new Event(EAction.CLOSE));
    setTimeout(() => {
      form1.submit();
    }, 100);
  };

  const onFinish = (values) => {
    onClose();
    const _v = transferValueToSubmit(values);
    onChange(_v);
    // console.log(form1.getFieldsValue());
  };

  const handleOnOpen = () => {
    form1.setFieldsValue(iniValue);
    setVisible(true);
  };

  return {
    Component: (
      <Fragment>
        <Filter
          title={getI18n('reports.reportpagecommon.reportFilters')}
          resetAll={resetAll}
          handleOnSubmit={handleOnSubmit}
          visible={visible}
          onClose={onClose}
          onFinish={onFinish}
          initialValues={iniValue}
          form={form1}>
          <React.Fragment>
            {(value || []).map((i) => (
              <React.Fragment key={i.type}>{map[i.type]}</React.Fragment>
            ))}
          </React.Fragment>
        </Filter>
      </Fragment>
    ),
    onOpen: handleOnOpen,
  };
};

export default useFilters;
